{
  "version": 1,
  "asset_id": "c12a2c5e-9461-4df4-95e4-7968d2863134",
  "project_id": "bc28ec3a-38d3-4a78-848c-5618f322d6de",
  "url": "/__l5e/assets-v1/c12a2c5e-9461-4df4-95e4-7968d2863134/timothy-ng-224.jpg",
  "r2_key": "a/v1/bc28ec3a-38d3-4a78-848c-5618f322d6de/c12a2c5e-9461-4df4-95e4-7968d2863134/timothy-ng-224.jpg",
  "original_filename": "timothy-ng-224.jpg",
  "size": 10720,
  "content_type": "image/jpeg",
  "created_at": "2026-07-29T18:51:42Z"
}
